import React, { useState } from "react";
import { TermBoxWrapper, TermLine, TermSelect, TermOption, MLabel } from './styles';

export const TermOccation = ({ setTermSearch, staffList }) => {
  const [staffID, setStaffID] = useState(0);


  return <TermBoxWrapper>
    <TermLine className="flex-wrap">
      <MLabel>担当者：</MLabel>
      <TermSelect className="title-text" value={staffID} onChange={(e) => {
        const num = Number(e.target.value || 1);
        setStaffID(num);
        setTermSearch((preValue) => ({ ...preValue, staffID: num }))
      }}>
        {staffList.map((item) => {
          return (<TermOption key={item.StaffID} value={item.StaffID}>{item.StaffName}</TermOption>);
        })}
      </TermSelect>
      <MLabel htmlFor="doing" style={{ marginLeft: "20px" }}>施工中</MLabel>
      <input id="doing" type="checkbox" onChange={(e) => {
        setTermSearch((preValue) => ({ ...preValue, isDoing: e.target.checked ? '1' : '' }))
      }
      } />

    </TermLine>
  </TermBoxWrapper>;
};
